<template>
  <div style="height:100%; font-size: 16px; padding-top: 15px; overflow:auto;">
    <SalseQRCodePage :salseQRCode="salseQRCode"></SalseQRCodePage>
  </div>
</template>

<script>
import SalseQRCodePage from "../components/Mobile/SalseQRCodePage";
import { MobileHomeHandler } from "@/handler/MobileHomeHandler.js";
export default {
  components: {
    SalseQRCodePage
  },
  created() {
    document.title = "業務QRCode";
    this.tutorChatToken = this.$route.query.tct;
    this.salseQRCode = MobileHomeHandler.GetSalseQRCodeURL(this.tutorChatToken);
  },
  data() {
    return {
      salseQRCode: ""
    };
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileSalseQRCodePageView.vue